// extracted by mini-css-extract-plugin
module.exports = {"link":"Icons_link__xN1x7","icon":"Icons_icon___e_uk","text":"Icons_text__UJIka"};